import React from 'react';
import { Form, Formik, Field } from 'formik';

import { useToast } from 'helpers/hooks';
import { Avatar } from 'legacy_components/Avatar';
import { Input } from 'legacy_components/Input';
import { ProfileFormBody } from 'legacy_components/ProfileFormBody';
import { ReactComponent as EditIcon } from 'assets/svg/edit.svg';
import { request } from 'helpers/tools';
import styles from 'legacy_css_modules/User.module.css';

export const User = ({ setUser, user }) => {
    const showToast = useToast();

    const bodyProps = {
        button: {
            text: 'Uložit změny',
            primary: true
        }
    };

    const handleImageUpload = (event, setFieldValue) => {
        const file = event.target.files[0];
        if (!file) return;

        setFieldValue('avatar', file);
        // Cleanly update local state preview without mutating props directly
        setUser(prev => ({ ...prev, avatar: URL.createObjectURL(file) }));
    };

    return (
        <Formik
            initialValues={{
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                username: user.username || '',
                email: user.email || '',
                telephone: user.telephone || '',
                id: user.pk || '',
                company_title: user.company_title || '',
                country: user.country?.title || user.country || '',
                display_notifications: user.display_notifications ? 'true' : 'false',
                legacy_frontend: user.legacy_frontend ? 'true' : 'false'
            }}
            onSubmit={async (values, { setErrors }) => {
                const data = new FormData();
                if (!user.is_admin) {
                    values.company_title = user.company_title;
                }

                Object.entries(values).forEach(([key, value]) => {
                    data.append(key, value);
                });

                const url = '/rest-auth/user/';
                const response = await request(url, 'PATCH', data, false, true);

                if (response.ok) {
                    const updatedUser = {
                        ...response.body,
                        client_company: typeof response.body.client_company === 'object'
                            ? response.body.client_company?.id
                            : response.body.client_company
                    };

                    setUser(updatedUser);
                    showToast('Změny byly uloženy');
                } else {
                    setErrors(response.body);
                }
            }}
        >
            {({ setFieldValue }) => (
                <Form className={styles.form}>
                    <label className={styles.avatarUpload}>
                        <input
                            name="avatar"
                            type="file"
                            accept="image/*"
                            onChange={event => handleImageUpload(event, setFieldValue)}
                            hidden
                        />
                        <div className={styles.avatarContainer}>
                            <Avatar user={user} />
                        </div>
                        <EditIcon className={styles.editIcon} />
                        <span className={styles.avatarUploadText}>Změnit profilové foto</span>
                    </label>

                    <ProfileFormBody {...bodyProps}>
                        <Input name="first_name" autoComplete="given-name" required>
                            Jméno
                        </Input>
                        <Input name="last_name" autoComplete="family-name" required>
                            Příjmení
                        </Input>
                        <Input name="username" autoComplete="username" required>
                            Uživatelské jméno
                        </Input>
                        <Input name="telephone" type="tel" autoComplete="tel">
                            Telefon
                        </Input>
                        <Input name="email" type="email" autoComplete="email">
                            Email
                        </Input>
                        <Input name="id" disabled>
                            ID uživatele
                        </Input>
                        <Input name="country" autoComplete="country" disabled>
                            Země
                        </Input>
                        <Input name="company_title" autoComplete="organization" disabled={!user.is_admin}>
                            Název společnosti
                        </Input>

                        {user.legacy_frontend_company === false && (
                            <>
                                <br />
                                <div style={{ marginTop: '0rem' }}>
                                    <div style={{ fontWeight: 'bold', color: 'rgb(178, 176, 189)', marginBottom: '0.3rem' }}>
                                        Nové uživatelské rozhraní
                                    </div>
                                    <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                            <Field type="radio" name="legacy_frontend" value="false" />
                                            <span>Ano</span>
                                        </label>
                                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
                                            <Field type="radio" name="legacy_frontend" value="true" />
                                            <span>Ne</span>
                                        </label>
                                    </div>
                                </div>
                            </>
                        )}
                    </ProfileFormBody>
                </Form>
            )}
        </Formik>
    );
};